export default __webpack_public_path__ + "static/media/np_check_1438094_000000.bdb4b296.svg";